import { render, staticRenderFns } from "./IconProfile.vue?vue&type=template&id=50d6a1e1"
import script from "./IconProfile.vue?vue&type=script&lang=ts"
export * from "./IconProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports